import client from './client.js';
import { deviceId } from '../lib/hub.js';

// Quiénes tienen PIN, para pintar "¿quién eres?"
export const getWaiters = () =>
  client.get('/pin/waiters').then((r) => r.data.data);

// Identifica sin abrir sesión nueva: devuelve quién es, no un token.
// `aparato` va en el cuerpo: si se falla cinco veces, se bloquea solo este
// aparato y no a todo el equipo. El encabezado X-Device-Id ya viaja en cada
// petición, pero la caja principal no lo reenvía a la nube; el cuerpo sí.
export const verifyPin = (pin) =>
  client.post('/pin/verify', { pin, aparato: deviceId }).then((r) => r.data.data);

export const setUserPin = (userId, pin) =>
  client.patch(`/pin/users/${userId}`, { pin }).then((r) => r.data);
